import { childVariantsUl } from './anim';
import { motion } from 'framer-motion';
import { UserMode } from '@/components/context/ModeContext';

import fb from '@/assets/icons/facebook.png';
import gmail from '@/assets/icons/gmail.png';
import insta from '@/assets/icons/instagram.png';
import lk from '@/assets/icons/linkedin.png';
import spotify from '@/assets/icons/spotify.png';

const fbLink = 'https://www.facebook.com/yaghmurassen';
const gmailLink = 'mailto:sainsony@gmail.com';
const instaLink = 'https://www.instagram.com/yaghmurassen/';
const spotifyLink =
  'https://open.spotify.com/user/189yzdre4rlm4gc8kuxa799ho?si=941dbbdedc554117';
const lkLink = 'https://www.linkedin.com/in/yaghmurassen/';

const socialLink = [
  {
    src: fb,
    link: fbLink,
  },
  {
    src: gmail,
    link: gmailLink,
  },
  {
    src: insta,
    link: instaLink,
  },
  {
    src: lk,
    link: lkLink,
  },
  {
    src: spotify,
    link: spotifyLink,
  },
];

const SocialLinks = () => {
  const { darkMode } = UserMode();

  return (
    <>
      {socialLink &&
        socialLink.map((e, idx) => {
          return (
            <motion.li
              key={idx}
              variants={childVariantsUl}
              initial="hidden"
              animate="visible"
              transition={{
                duration: 0.5,
                delay: idx * 0.2,
              }}
              whileHover={{
                scale: 1.2,
                opacity: 0.8,
                transition: { duration: 0.1 },
              }}
              whileTap={{
                scale: 0.8,
                transition: { duration: 0.01 },
              }}
            >
              <a href={e.link} target="_blank" rel="noopener noreferrer">
                <img
                  className={darkMode ? 'h-6 w-6 invert-[1]' : 'h-6 w-6'}
                  src={e.src}
                />
              </a>
            </motion.li>
          );
        })}
    </>
  );
};

export default SocialLinks;
